import React, { useState, useEffect } from "react";
import { Modal, Button, Spin } from "antd";
import { bmr_overall_pdf_report } from "../utils/api";

const Base64Viewer = ({ batch_number, open, onClose }) => {
  const [base64Data, set_base64Data] = useState("");
  const [loading, setLoading] = useState(false);
  const fileType = "pdf"; // change to "image" if you're rendering images

  const fetchBase64Data = async () => {
    try {
      setLoading(true);
      await bmr_overall_pdf_report({ batch_number }, (res) => {
        if (res?.data?.status === "success") {
          set_base64Data(res?.data?.data); // adjust this path based on actual API response
        } else {
          set_base64Data("");
        }
        setLoading(false);
      });
    } catch (error) {
      console.error("Error fetching base64 data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      fetchBase64Data();
    }
  }, [batch_number, open]);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={1700}
      title="BMR Report Preview"
      centered
      zIndex={2000} // use as number, not string
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: 40 }}>
          <Spin size="large" />
        </div>
      ) : base64Data ? (
        fileType === "image" ? (
          <img
            src={`data:image/png;base64,${base64Data}`}
            alt="Base64 Image"
            style={{
              maxWidth: "100%",
              height: "auto",
              border: "1px solid #ccc",
            }}
          />
        ) : (
          <iframe
            src={`data:application/pdf;base64,${base64Data}`}
            title="PDF Viewer"
            width="100%"
            height="800px"
            style={{ border: "1px solid #ccc" }}
          />
        )
      ) : (
        <div style={{ textAlign: "center", padding: 40 }}>
          No data available
        </div>
      )}
    </Modal>
  );
};

export default Base64Viewer;
